import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { RootState } from '../index'
import { AdminUser } from '../slices/authSlice'

export interface LoginRequest {
  email: string
  password: string
}

export interface LoginResponse {
  success: boolean
  data: {
    user: AdminUser
    token: string
  }
  message: string
}

export interface VerifyTokenResponse {
  success: boolean
  data: {
    user: AdminUser
  }
  message: string
}

export interface LogoutResponse {
  success: boolean
  message: string
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1/admin/auth',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      headers.set('Content-Type', 'application/json')
      headers.set('Accept', 'application/json')
      return headers
    },
    timeout: 10000,
  }),
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/login',
        method: 'POST',
        body: credentials,
      }),
      transformErrorResponse: (response: any, meta) => {
        console.error('Login API Error:', response, meta)
        return response
      },
    }),
    verifyToken: builder.query<VerifyTokenResponse, void>({
      query: () => ({
        url: '/verify',
        method: 'GET',
      }),
      transformResponse: (response: any) => response,
    }),
    logout: builder.mutation<LogoutResponse, void>({
      query: () => ({
        url: '/logout',
        method: 'POST',
      }),
    }),
  }),
})

export const { useLoginMutation, useVerifyTokenQuery, useLogoutMutation } = authApi 